import { OauthApiOauthAuthorizeRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation'

export const useOAuthAuthorizeMutation = () =>
  useBaseMutation({
    mutationFn: (req: OauthApiOauthAuthorizeRequest, config) =>
      appApiClient.oauthApi.oauthAuthorize(req, config),
  })
